<template>
  <div class="card">
    <!-- Card header -->
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <h3 class="mb-0">Permissões</h3>
        </div>
        <div class="col-md-4">
          <base-switch
            v-model="permitAll"
            type="permission"
            label="Todas" 
          ></base-switch>
        </div>
      </div>
    </div>
    <!-- Card content -->
    <div class="card-body">
      <!-- Search form -->
      <base-input
        class="input-group-lg input-group-flush mb-0"
        prepend-icon="fas fa-search"
        :placeholder="'Pesquisar Permissões'"
        v-model="q"
        @input="filterData()"
        type="search"
      ></base-input>
      <collapse>
        <collapse-item v-for="permission in sortedPermissions" :key="permission.controller" wrapperClasses="" :title="permission.name">
          <div class="row">
            <div class="col-6" v-for="(action, index) in permission.sortedActions" :key="action.action">
              <div class="mb-2">
                <el-tooltip 
                  content="Permissão já definida no grupo em que o usuário faz parte" 
                  placement="top-start"
                  :disabled="!isDisabled(selectedActions[permission.controller][action.action_index])"
                >
                  <base-switch
                    @input="onSelection($event, permission, action.action_index)"
                    :disabled="isDisabled(selectedActions[permission.controller][action.action_index])"
                    :label="action.name" 
                    :value="
                      selectedActions[permission.controller][action.action_index].checked || 
                        (selectedActions[permission.controller][Object.keys(selectedActions[permission.controller]) .length -1].checked) || 
                        permitAll
                    "
                  />
                </el-tooltip>
              </div>
            </div>
          </div>  
        </collapse-item>
      </collapse>
    </div>
    <!-- Paginator -->
    <div class="card-footer py-4 d-flex justify-content-end">
      <base-pagination v-on:input="changePage" v-model="paginated_data.current"
        :total="paginated_data.count" :perPage="paginated_data.per_page">
      </base-pagination>
    </div>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse'
import CollapseItem from '@/components/Collapse/CollapseItem'
import { Tooltip } from 'element-ui'

export default {
  name: "permissions-card",
  components: {
    Tooltip,
    Collapse,
    CollapseItem,
  },
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
    selectedItemType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      controllerPermissions: [],
      permissions: [],
      paginated_data: {},
      selectedActions: {},
      q: null,
      permitAll: false,
    }
  },
  mounted() {
    this.getControllerPermissions();
    this.getPermissions();
  },
  methods: {
    getControllerPermissions(){
      if(!this.$currentUser().id) return null

      let path = `/api/v1/users/${this.$currentUser().id}/permissions`
      this.$http.secured.get(path, {params: {permissionable_controllers: true}})
      .then(response => {
        const permissions = response.data;
        this.controllerPermissions = permissions.sort((a,b) => a.name.localeCompare(b.name))
      })
    },
    permissionsPath() {
      let path = '/api/v1/'
      if(this.selectedItemType == 'group') path += 'roles'
      else if(this.selectedItemType == 'user') path += 'users'
      else path += this.selectedItemType
      path += `/${this.selectedItem.id}/permissions`

      return path
    },
    getPermissions(){
      if(!this.selectedItemType || !this.selectedItem.id) return null

      this.$http.secured.get(this.permissionsPath()).then(response => {
        this.permissions = response.data || [];
      }).then(() => {
        
        let allPermission = this.permissions.find(e => 
          e.subject_class == 'total'
        )

        if(allPermission){
          this.permitAll = true;
        } else {
          this.permitAll = false;
        }
      })
    },
    changePage(page) {
      // this.getData(page);
    },
    initSelectedActions(){
      var selectedActions = {}
      this.controllerPermissions.forEach(permission => {
        selectedActions[permission.controller] = {}
        permission.actions.forEach((action) => {
          selectedActions[permission.controller][action.action_index] = {
            id: null,
            checked: false,
            subject_class: permission.controller,
            action: action.action_index,
          }
        })
      });
      this.selectedActions = selectedActions
    },
    isDisabled(permission) {
      if(!permission.type) return false
      if(this.selectedItemType === 'group' && permission.type !== 'Role') return true
      if(this.selectedItemType === 'user'  && permission.type !== 'User') return true
      return false
    },
    onPermissionChange(permission) {
      console.log(permission)
      if(!permission.checked && permission.id) return this.destroyPermission(permission)
      if(!permission.checked)                  return
      if(permission.checked  && permission.id) return this.updatePermission(permission)
      if(permission.checked)                   return this.createPermission(permission)
    },
    createPermission(permission) {
      console.log(permission)
      this.$http.secured.post(this.permissionsPath(), {
        permission: {
          action: permission.action,
          subject_class: permission.subject_class,
        }
      }).then((response) => {
        permission.id = response.data.id
      }).catch((error) => {
        permission.checked = false
      })
    },
    updatePermission(permission) {
      console.log(permission)
      this.$http.secured.put(this.permissionsPath()+'/'+permission.id, {
        permission: {
          action: permission.action.action_index,
          subject_class: permission.subject_class,
        }
      }).catch((error) => {
        permission.checked = false
      })
    },
    destroyPermission(permission) {
      this.$http.secured.delete(this.permissionsPath()+'/'+permission.id)
      .then(() => {
        permission.id = null
      })
      .catch((error) => {
        permission.checked = true
      })
    },
    permissionChecked(selectedActions, permission){
      let lastIndex = Object.keys(selectedActions[permission.controller]).length - 1

      return permission.checked || selectedActions[permission.controller][lastIndex].checked
    },
    onSelection(event, permission, index){
      this.selectedActions[permission.controller][index].checked = event; 
      this.onPermissionChange(this.selectedActions[permission.controller][index]);
      // this.selectedActions[permission.controller][index].checked = event; 
    }
  },
  computed: {
    filteredPermissions() {
      if(!this.q) return this.controllerPermissions
      return this.controllerPermissions.filter(permission => permission.name.toLowerCase().includes(this.q.toLowerCase()))
    },
    sortedPermissions() {
      return this.filteredPermissions.map(permission => ({
        ...permission,
        sortedActions: [...permission.actions].sort((a, b) => a.name.localeCompare(b.name))
      }));
    },
  },
  watch: {
    selectedItem(){
      this.getPermissions();
    },
    controllerPermissions(){
      this.initSelectedActions()
    },
    permissions(newPermissions, _oldPermissions) {
      this.initSelectedActions()

      newPermissions.forEach(permission => {
        this.selectedActions[permission.subject_class][permission.action] = {
          id: permission.id,
          checked: true,
          type: permission.permissionable_type,
          subject_class: permission.subject_class,
          action: permission.action,
        }
      });
    },
    permitAll(event) {
      var allPermission = this.selectedActions['total'][0]
       
      if (event){
        if (!allPermission || !allPermission.id) {
          this.$http.secured.post(this.permissionsPath(), {
            permission: {
              action: 0,
              subject_class: "total",
            }
          }).then((response) => {
            allPermission.id = response.data.id
          }).catch((error) => {
            allPermission.checked = false
          })
        }
      }
       else {
        if (allPermission) {
          this.$http.secured.delete(this.permissionsPath()+'/'+allPermission.id)
          .then(() => {
            allPermission.id = null
          })
          .catch((error) => {
            allPermission.checked = true
          })
        }
      }
    }
  },
};
</script>
